import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import React from "react";
import { useHistory, useParams } from "react-router";

import { TitleTypeApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { TitleTypeDetails } from "./TitleTypeDetails";
import { useApiEffect } from "nsitools-react";

export interface ITitleTypeItemPageProps {}

export const TitleTypeItemPage: React.FunctionComponent<ITitleTypeItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const { currentLanguage } = useGlobalData();
  const api = useApiService(TitleTypeApi);
  const history = useHistory();
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id, currentLanguage.languageId), []);

  return (
    <>
      <PageBase
        breadCrumbs={[
          { text: t(ETLCodes.TitleTypes), route: ERoutes.titleType },
          { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
        ]}
      >
        <ProtectedTabs
          id="TabsTitleTypes"
          onChange={(newTabId) => history.push(`${ERoutes.titleType}/${id}/${newTabId}/${state}`)}
          selectedTabId={tab}
          renderActiveTabPanelOnly
        >
          <BackButton backRoute={ERoutes.titleType} />
          <Tab
            id="detail"
            title={t(ETLCodes.Detail)}
            panel={<TitleTypeDetails titleTypeId={+id} editMode={state === "edit"} />}
          />
        </ProtectedTabs>
      </PageBase>
    </>
  );
};
